// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
/** Greif Custom Code
 * import {
    formFieldDescriptionWrapperVariantStyles,
    formFieldInputSelectDisabledStyles,
    formFieldInputSelectIconStyles,
    formFieldLabelStyles,
    formFieldVariantStyles,
} from "@store/Themes/common/mixins/formField";
 */

import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Greif Custom Code - Start */
import {
    formFieldDescriptionWrapperStyles,
    formFieldInputSelectDisabledStyles,
    formFieldInputSelectIconStyles,
    formFieldVariantStyles,
} from "@store/Themes/common/mixins/formField";
/* Greif Custom Code - End */

/* ------------------------------------------------------------------------------------------ */
/* Related Extensions => src/Extensions/Mobius/FormField ------------------------------------ */
/* ------------------------------------------------------------------------------------------ */

const formField: Styleguide["formField"] = {
    defaultProps: {
        border: "rounded",
        backgroundColor: "common.background",
        labelProps: {
            css: css`
                ${({ theme }) => css`
                    font-weight: ${theme.design.typography.weight.bold};
                    line-height: ${theme.design.typography.lineHeight.semi};
                `}
            `,
        },
        errorProps: {
            color: "danger",
            size: "inherit",
            weight: "inherit",
            /* Greif Custom Code - Start */
            css: css`
                display: flex;
                align-items: center;
            `,
            /* Greif Custom Code - End */
        },
        hintProps: {
            color: "text", // Greif
            size: "inherit",
            weight: "inherit",
            /* Greif Custom Code - Start */
            css: css`
                display: flex;
                align-items: center;
            `,
            /* Greif Custom Code - End */
        },
        cssOverrides: {
            inputSelect: css`
                ${formFieldVariantStyles()}
                ${formFieldInputSelectIconStyles("primary", "primary.dark")}
                ${formFieldInputSelectDisabledStyles("text.disabled", "common.disabled")}
                color: ${getColor("text.input")};
            `,
            descriptionWrapper: css`
                ${formFieldDescriptionWrapperStyles()}
                font-weight: ${x => x.theme.design.typography.weight.base}; /* Greif */
            `,
        },
    },
};

export default formField;
